import React, { useState, useEffect } from "react";
import {
  Button,
  Typography,
  Modal,
  Grid,
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Chip,
  Paper,
  Avatar,
  Stack,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { API_URL } from "../../../Config/api";
import PercentIcon from "@mui/icons-material/Percent";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PaymentsIcon from "@mui/icons-material/Payments";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoneAllIcon from "@mui/icons-material/DoneAll";

const mainModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", md: "85%", lg: "75%" },
  maxHeight: "90vh",
  bgcolor: "#F4F7FA",
  borderRadius: "24px",
  boxShadow: "0 30px 60px -12px rgba(0, 0, 0, 0.3)",
  overflowY: "auto",
  p: 0,
  "&::-webkit-scrollbar": { width: "6px" },
  "&::-webkit-scrollbar-track": { background: "transparent" },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#CBD5E1",
    borderRadius: "10px",
  },
};

const CardHeader = ({ icon, title, color }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1.5,
      mb: 2,
      pb: 1.5,
      borderBottom: "1px dashed #E2E8F0",
    }}
  >
    <Avatar sx={{ bgcolor: `${color}15`, color: color, width: 32, height: 32 }}>
      {icon}
    </Avatar>
    <Typography variant="subtitle1" fontWeight={700} color="#334155">
      {title}
    </Typography>
  </Box>
);

const DetailItem = ({ icon, label, value }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "flex-start",
      gap: 1.5,
      mb: 1.5,
      width: "100%",
    }}
  >
    <Box sx={{ color: "#94A3B8", mt: 0.2, minWidth: "24px" }}>{icon}</Box>
    <Box sx={{ width: "calc(100% - 36px)", overflow: "hidden" }}>
      <Typography
        variant="caption"
        fontWeight={600}
        color="#64748B"
        sx={{
          display: "block",
          mb: 0.2,
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        fontWeight={600}
        color="#1E293B"
        sx={{ wordBreak: "break-word", whiteSpace: "normal" }}
      >
        {value || "N/A"}
      </Typography>
    </Box>
  </Box>
);

const PackageEventDetails = ({ eveID, onClose, discountTypeName }) => {

  console.log(discountTypeName, "discountTypeNamediscountTypeName")
  const [eventData, setEventData] = useState(null);
  console.log(eventData, "eventDataeventData")
  const [isLoading, setIsLoading] = useState(true);
  const [openSessions, setOpenSessions] = useState(false);
  const [activeServiceSessions, setActiveServiceSessions] = useState([]);

  useEffect(() => {
    const getPackageEventDetails = async () => {
      if (!eveID) return;

      setIsLoading(true);
      const accessToken = localStorage.getItem("token");

      try {
        const res = await fetch(
          `${API_URL}/packages/OnClinkEventCodeDetails/?eve_id=${eveID}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        const data = await res.json();
        setEventData(data);
      } catch (error) {
        console.error("Failed to fetch package details:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getPackageEventDetails();
  }, [eveID]);

  if (isLoading) {
    return (
      <Box
        sx={{
          ...mainModalStyle,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "300px",
        }}
      >
        <Typography variant="h6" color="#64748B">
          Loading details...
        </Typography>
      </Box>
    );
  }

  const { caller_details, patient_details, services_details, payment_details } =
    eventData || {};

  // FIXED: Evaluates if payment_details is a populated object instead of an array
  const payment =
    payment_details && Object.keys(payment_details).length > 0
      ? payment_details
      : null;
  // const isPaid = !!payment;

  const paymentStatus = payment?.overall_status;

  const isPaid = paymentStatus === "Paid" || paymentStatus === "SUCCESS";
  const isPartial = paymentStatus === "Partial";

  // FIXED: Uses package_cost based on the JSON payload structure
  const calculatedTotal =
    services_details?.reduce(
      (acc, curr) => acc + (curr.package_cost || 0),
      0,
    ) || 0;

  // Use payment.Total_cost if available, fallback to calculatedTotal
  const displayTotal = payment?.Total_cost
    ? parseFloat(payment.Total_cost)
    : calculatedTotal;

  return (
    <Box sx={mainModalStyle}>
      <Box
        sx={{
          px: 4,
          py: 2.5,
          background:
            "linear-gradient(90deg, rgb(100 154 141) 40%, rgb(92 173 130) 100%)",
          color: "#fff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "sticky",
          top: 0,
          zIndex: 10,
        }}
      >
        <Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 800,
              letterSpacing: "-0.5px",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            PACKAGE DETAILS
          </Typography>
          <Typography variant="body2" sx={{ color: "#E0F2FE", mt: 0.5 }}>
            Details of caller, patient, services, and billing.
          </Typography>
        </Box>
        <IconButton
          onClick={onClose}
          sx={{
            color: "#fff",
            bgcolor: "rgba(255,255,255,0.15)",
            backdropFilter: "blur(10px)",
            "&:hover": { bgcolor: "rgba(255,255,255,0.3)" },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <Box sx={{ p: { xs: 1, md: 2 } }}>
        {/* 2. Caller & Patient Info Cards */}
        <Grid container spacing={2} sx={{ mb: 4 }}>
          {/* Caller Details */}
          <Grid item xs={12} md={5}>
            <Paper
              elevation={0}
              sx={{
                p: 2,
                borderRadius: "20px",
                border: "1px solid #E2E8F0",
                bgcolor: "#fff",
                height: "100%",
              }}
            >
              <CardHeader
                icon={<PhoneOutlinedIcon fontSize="small" />}
                title="Caller Profile"
                color="#3B82F6"
              />
              <DetailItem
                icon={<PersonOutlineIcon fontSize="small" />}
                label="Full Name"
                value={caller_details?.caller_fullname}
              />
              <DetailItem
                icon={<PhoneOutlinedIcon fontSize="small" />}
                label="Contact Number"
                value={`+91 ${caller_details?.phone}`}
              />
            </Paper>
          </Grid>

          {/* Patient Details */}
          <Grid item xs={12} md={7}>
            <Paper
              elevation={0}
              sx={{
                p: 2,
                borderRadius: "20px",
                border: "1px solid #E2E8F0",
                bgcolor: "#fff",
                height: "100%",
              }}
            >
              <CardHeader
                icon={<PersonOutlineIcon fontSize="small" />}
                title="Patient Profile"
                color="#10B981"
              />
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                  <DetailItem
                    icon={<PersonOutlineIcon fontSize="small" />}
                    label="Patient Name"
                    value={patient_details?.name}
                  />
                  <DetailItem
                    icon={<CalendarMonthOutlinedIcon fontSize="small" />}
                    label="Age - Gender"
                    value={`${patient_details?.Age} Yrs • ${patient_details?.gender}`}
                  />
                  <DetailItem
                    icon={<MedicalServicesOutlinedIcon fontSize="small" />}
                    label="Suffered From"
                    value={patient_details?.Suffered_from || "Not specified"}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <DetailItem
                    icon={<PhoneOutlinedIcon fontSize="small" />}
                    label="Contact Number"
                    value={`+91 ${patient_details?.phone_no}`}
                  />
                  <DetailItem
                    icon={<EmailOutlinedIcon fontSize="small" />}
                    label="Email Address"
                    value={patient_details?.patient_email_id}
                  />
                  <DetailItem
                    icon={<LocationOnOutlinedIcon fontSize="small" />}
                    label="Google Address"
                    value={`${patient_details?.google_address || ""}`}
                  // value={`${patient_details?.address || ""}, ${patient_details?.city_name || ""}, ${patient_details?.state_name || ""} (Zone: ${patient_details?.prof_zone_id || ""})`}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>

        {/* 3. Services Details Table */}
        <Paper
          elevation={0}
          sx={{
            borderRadius: "20px",
            border: "1px solid #E2E8F0",
            overflow: "hidden",
            mb: 2,
            mt: 6.5,
            bgcolor: "#fff",
          }}
        >
          <Box
            sx={{
              px: 3,
              py: 1.5,
              borderBottom: "1px solid #E2E8F0",
              bgcolor: "#F8FAFC",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Avatar
                sx={{
                  bgcolor: "#F59E0B15",
                  color: "#F59E0B",
                  width: 35,
                  height: 35,
                }}
              >
                <MedicalServicesOutlinedIcon fontSize="small" />
              </Avatar>
              <Typography variant="h6" fontWeight={700} color="#334155">
                Allocated Services
              </Typography>
            </Box>
            <Chip
              label={`${services_details?.length || 0} Services`}
              size="small"
              sx={{ bgcolor: "#E2E8F0", fontWeight: 700, color: "#334155" }}
            />
          </Box>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {[
                    "SERVICE DETAILS",
                    "HOSPITAL / DOCTOR",
                    "SESSIONS",
                    "ACTION",
                  ].map((head) => (
                    <th
                      key={head}
                      style={{
                        padding: "16px 24px",
                        textAlign: "left",
                        fontSize: "0.75rem",
                        fontWeight: 700,
                        color: "#64748B",
                        letterSpacing: "0.5px",
                        borderBottom: "2px solid #E2E8F0",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {head}
                    </th>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {services_details?.map((s, i) => (
                  <TableRow
                    key={i}
                    hover
                    sx={{
                      "&:last-child td": { border: 0 },
                      transition: "0.2s",
                    }}
                  >
                    <td
                      style={{
                        padding: "16px 24px",
                        borderBottom: "1px solid #F1F5F9",
                        maxWidth: "250px",
                      }}
                    >
                      <Typography
                        variant="body2"
                        fontWeight={800}
                        color="#1E293B"
                        sx={{ wordBreak: "break-word" }}
                      >
                        {s.service_name}
                      </Typography>
                      <Typography
                        variant="caption"
                        fontWeight={600}
                        color="#64748B"
                        sx={{ wordBreak: "break-word" }}
                      >
                        {s.sub_service_name}
                      </Typography>
                    </td>
                    <td
                      style={{
                        padding: "16px 24px",
                        borderBottom: "1px solid #F1F5F9",
                        maxWidth: "200px",
                      }}
                    >
                      <Typography
                        variant="body2"
                        fontWeight={600}
                        color="#334155"
                        sx={{ wordBreak: "break-word" }}
                      >
                        {s.hospital_name}
                      </Typography>
                      <Typography
                        variant="caption"
                        color="#94A3B8"
                        sx={{ wordBreak: "break-word" }}
                      >
                        Ref: Dr. {s.doctor_cons_name || "N/A"}
                      </Typography>
                    </td>
                    <td
                      style={{
                        padding: "16px 24px",
                        borderBottom: "1px solid #F1F5F9",
                      }}
                    >
                      <Chip
                        // label={`${s.session_count} Sessions`}
                        label={`${s.session_count} ${s.session_count === 1 ? "Session" : "Sessions"}`} size="small"
                        sx={{
                          bgcolor: "#F1F5F9",
                          color: "#334155",
                          fontWeight: 700,
                          borderRadius: "6px",
                        }}
                      />
                    </td>
                    <td
                      style={{
                        padding: "16px 24px",
                        borderBottom: "1px solid #F1F5F9",
                      }}
                    >
                      <Button
                        size="small"
                        variant="outlined"
                        startIcon={<RemoveRedEyeOutlinedIcon />}
                        sx={{
                          borderRadius: "8px",
                          textTransform: "none",
                          fontWeight: 600,
                          color: "#3B82F6",
                          borderColor: "#DBEAFE",
                          bgcolor: "#EFF6FF",
                          "&:hover": {
                            bgcolor: "#DBEAFE",
                            borderColor: "#BFDBFE",
                          },
                        }}
                        onClick={() => {
                          setActiveServiceSessions(s.session);
                          setOpenSessions(true);
                        }}
                      >
                        View
                      </Button>
                    </td>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {
          discountTypeName === "complimentary" ?
            (
              <Paper
                elevation={0}
                sx={{
                  borderRadius: "20px",
                  border: "1px solid #BBF7D0",
                  overflow: "hidden",
                  bgcolor: "#F0FDF4",
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  p: 2.5,
                  minHeight: "100px",
                }}
              >
                <Box
                  sx={{
                    width: 52,
                    height: 52,
                    borderRadius: "16px",
                    bgcolor: "#DCFCE7",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Typography sx={{ fontSize: "26px" }}>🎁</Typography>
                </Box>

                <Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 700,
                      color: "#166534",
                      mb: 0.5,
                    }}
                  >
                    Complimentary Service
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#4B5563",
                      lineHeight: 1.5,
                    }}
                  >
                    No payment or billing details are available because this service
                    is provided complimentary.
                  </Typography>
                </Box>
              </Paper>
            )
            :
            (
              <Paper
                elevation={0}
                sx={{
                  borderRadius: "20px",
                  border: "1px solid",
                  borderColor: isPaid ? "#A7F3D0" : "#FDE68A",
                  overflow: "hidden",
                  bgcolor: "#fff",
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <Box
                  sx={{
                    p: 2,
                    width: { xs: "100%", md: "35%" },
                    bgcolor: isPaid ? "#ECFDF5" : "#FFFBEB",
                    borderRight: {
                      md: `1px solid ${isPaid ? "#A7F3D0" : "#FDE68A"}`,
                    },
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "flex-start",
                  }}
                >
                  {/* <Avatar
                    sx={{
                      bgcolor: isPaid
                        ? "#10B981"   // Green - Success
                        : isPartial
                          ? "#F97316"   // Orange - Partial
                          : "#F59E0B",  // Yellow - Pending
                      color: "#fff",
                      width: 56,
                      height: 56,
                      mb: 2,
                      boxShadow: "0 4px 14px rgba(0,0,0,0.1)",
                    }}
                  >
                    {isPaid ? (
                      <CheckCircleOutlineIcon fontSize="medium" />
                    ) : isPartial ? (
                      <WarningAmberOutlinedIcon fontSize="medium" />
                    ) : (
                      <WarningAmberOutlinedIcon fontSize="medium" />
                    )}
                  </Avatar> */}

                  <Typography
                    variant="body2"
                    color={
                      isPaid
                        ? "#059669"   // Green
                        : isPartial
                          ? "#EA580C"   // Orange
                          : "#D97706"   // Yellow
                    }
                    fontWeight={700}
                    sx={{
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                      mb: 0.5,
                    }}
                  >
                    {isPaid
                      ? "Total Paid"
                      : isPartial
                        ? "Remaining Amount To Be Paid"
                        : "Total Payable"}
                  </Typography>
                  {/* <Avatar
              sx={{
                bgcolor: isPaid ? "#10B981" : "#F59E0B",
                color: "#fff",
                width: 56,
                height: 56,
                mb: 2,
                boxShadow: "0 4px 14px rgba(0,0,0,0.1)",
              }}
            >
              {isPaid ? (
                <CheckCircleOutlineIcon fontSize="medium" />
              ) : (
                <WarningAmberOutlinedIcon fontSize="medium" />
              )}
            </Avatar>
            <Typography
              variant="body2"
              color={isPaid ? "#059669" : "#D97706"}
              fontWeight={700}
              sx={{ textTransform: "uppercase", letterSpacing: "1px", mb: 0.5 }}
            >
              {isPaid ? "Total Paid" : "Total Payable"}
            </Typography> */}
                  <Typography
                    variant="h3"
                    fontWeight={800}
                    color="#1E293B"
                    sx={{ letterSpacing: "-1px", wordBreak: "break-word" }}
                  >
                    ₹
                    {isPartial
                      ? Number(payment?.amount_remaining || 0).toLocaleString("en-IN")
                      : displayTotal}
                  </Typography>

                  <Chip
                    icon={
                      isPaid ? (
                        <CheckCircleOutlineIcon
                          sx={{ fontSize: "16px !important" }}
                        />
                      ) : (
                        <WarningAmberOutlinedIcon
                          sx={{ fontSize: "16px !important" }}
                        />
                      )
                    }
                    label={
                      isPaid
                        ? "Payment Successful"
                        : isPartial
                          ? "Partial Payment"
                          : "Payment Pending"
                    }
                    // label={isPaid ? "Payment Successful" : "Payment Pending"}
                    sx={{
                      mt: 2,
                      bgcolor: isPaid
                        ? "#10B981"   // Green - Success
                        : isPartial
                          ? "#F97316"   // Orange - Partial
                          : "#F59E0B",  // Yellow - Pending
                      // bgcolor: isPaid ? "#10B981" : "#F59E0B",
                      color: "#fff",
                      fontWeight: 700,
                      borderRadius: "8px",
                      border: "none",
                    }}
                  />
                </Box>

                {/* Right Side: Billing Breakdown Grid */}
                <Box sx={{ p: 2, width: { xs: "100%", md: "65%" } }}>
                  <Typography
                    variant="h6"
                    fontWeight={700}
                    color="#334155"
                    sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1, borderBottom: "1px dashed #E2E8F0" }}
                  >
                    <ReceiptLongOutlinedIcon color="action" /> Billing Summary
                  </Typography>

                  {isPaid || isPartial ? (
                    <Grid container spacing={4}>
                      {/* Payment Date */}
                      <Grid item xs={12} sm={6}>
                        <DetailItem
                          icon={<CalendarMonthOutlinedIcon fontSize="small" />}
                          label="Payment Date"
                          value={payment.date?.slice(0, 10)}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <DetailItem
                          icon={<AccountBalanceWalletOutlinedIcon fontSize="small" />}
                          label="Payment Mode"
                          value={payment.utrs?.[0]?.mode || "N/A"}
                        />
                      </Grid>

                      {/* Paid By
                      <Grid item xs={12} sm={4}>
                        <DetailItem
                          icon={<ReceiptLongOutlinedIcon fontSize="small" />}
                          label="Paid By"
                          value={payment.utrs?.paid_by || "N/A"}
                        />
                      </Grid> */}

                      {/* <Grid item xs={12}>
                        <Divider sx={{ my: 0, borderStyle: "dashed" }} />
                      </Grid> */}

                      {/* Discount Type */}
                      <Grid item xs={12} sm={6}>
                        <DetailItem
                          icon={<MedicalServicesOutlinedIcon fontSize="small" />}
                          label="Discount Type"
                          value={payment.discount_type?.replace("_", " ")}
                        />
                      </Grid>

                      {/* Discount Amount */}
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ width: "100%", overflow: "hidden" }}>
                          <Typography
                            variant="caption"
                            fontWeight={600}
                            color="#64748B"
                            sx={{
                              display: "block",
                              mb: 0.2,
                              textTransform: "uppercase",
                            }}
                          >
                            Discount Amount
                          </Typography>

                          <Typography
                            variant="body1"
                            fontWeight={800}
                            color="#E11D48"
                            sx={{
                              wordBreak: "break-word",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "3px",
                            }}
                          >
                            {payment.discount_value}

                            {payment.discount_type === "In_Percentage" ? (
                              <PercentIcon fontSize="small" />
                            ) : payment.discount_type === "In_amount" ? (
                              <CurrencyRupeeIcon fontSize="small" />
                            ) : payment.discount_type === "complimentary" ? (
                              <CardGiftcardIcon fontSize="small" />
                            ) : payment.discount_type === "VIP" ? (
                              <WorkspacePremiumIcon fontSize="small" />
                            ) : payment.discount_type === "No_discount" ? (
                              null
                            ) : (
                              <CurrencyRupeeIcon fontSize="small" />
                            )}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  ) : (
                    // Pending / no payment
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "70%",
                        opacity: 0.7,
                      }}
                    >
                      <ReceiptLongOutlinedIcon
                        sx={{ fontSize: 50, color: "#94A3B8", mb: 2 }}
                      />

                      <Typography variant="h6" color="#64748B" fontWeight={600}>
                        No Payment Records Found
                      </Typography>

                      <Typography
                        variant="body2"
                        color="#94A3B8"
                        sx={{ textAlign: "center" }}
                      >
                        The payment for this package has not been processed yet.
                      </Typography>
                    </Box>
                  )}

                  {/* {isPaid ? (
              <Grid container spacing={4}>
                <Grid item xs={12} sm={4}>
                  <DetailItem
                    icon={<CalendarMonthOutlinedIcon fontSize="small" />}
                    label="Payment Date"
                    value={payment.date?.slice(0, 10)}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <DetailItem
                    icon={<AccountBalanceWalletOutlinedIcon fontSize="small" />}
                    label="Payment Mode"
                    value={payment.utrs?.[0]?.mode || "N/A"}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <DetailItem
                    icon={<ReceiptLongOutlinedIcon fontSize="small" />}
                    label="Paid By"
                    value={payment.utrs?.[0]?.paid_by || "N/A"}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Divider sx={{ my: 1, borderStyle: "dashed" }} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <DetailItem
                    icon={<MedicalServicesOutlinedIcon fontSize="small" />}
                    label="Discount Type"
                    value={payment.discount_type?.replace("_", " ")}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box sx={{ width: "100%", overflow: "hidden" }}>
                    <Typography
                      variant="caption"
                      fontWeight={600}
                      color="#64748B"
                      sx={{
                        display: "block",
                        mb: 0.2,
                        textTransform: "uppercase",
                      }}
                    >
                      Discount Amount
                    </Typography>

                    <Typography
                      variant="body1"
                      fontWeight={800}
                      color="#E11D48"
                      sx={{
                        wordBreak: "break-word",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "3px",
                      }}
                    >
                      {
                        payment.discount_value
                      }
                      {payment.discount_type === "In_Percentage" ? (
                        <PercentIcon fontSize="small" />
                      ) : payment.discount_type === "In_amount" ? (
                        <CurrencyRupeeIcon fontSize="small" />
                      ) : payment.discount_type === "complimentary" ? (
                        <CardGiftcardIcon fontSize="small" />
                      ) : payment.discount_type === "VIP" ? (
                        <WorkspacePremiumIcon fontSize="small" />
                      ) : payment.discount_type === "No_discount" ? (
                        null
                      ) : (
                        <CurrencyRupeeIcon fontSize="small" />
                      )}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "70%",
                  opacity: 0.7,
                }}
              >
                <ReceiptLongOutlinedIcon
                  sx={{ fontSize: 50, color: "#94A3B8", mb: 2 }}
                />
                <Typography variant="h6" color="#64748B" fontWeight={600}>
                  No Payment Records Found
                </Typography>
                <Typography
                  variant="body2"
                  color="#94A3B8"
                  sx={{ textAlign: "center" }}
                >
                  The payment for this package has not been processed yet.
                </Typography>
              </Box>
            )} */}
                </Box>
              </Paper>
            )
        }

        {eventData?.payment_details?.utrs?.length > 0 && (
          <Paper
            elevation={0}
            sx={{
              p: 2,
              mt: 2,
              borderRadius: "20px",
              border: "1px solid #E2E8F0",
              bgcolor: "#fff",
              height: "100%",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1,
              }}
            >
              <Box>
                <Typography
                  variant="h6"
                  fontWeight={700}
                  color="#334155"
                  ml={1}
                >
                  UTR Details
                </Typography>
              </Box>

              <Box
                sx={{
                  px: 1.5,
                  py: 0.7,
                  borderRadius: "20px",
                  backgroundColor: "#EFF6FF",
                  border: "1px solid #DBEAFE",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "11px",
                    fontWeight: 800,
                    color: "#2563EB",
                  }}
                >
                  {eventData.payment_details.utrs.length}{" "}
                  {eventData.payment_details.utrs.length === 1
                    ? "Transaction"
                    : "Transactions"}
                </Typography>
              </Box>
            </Box>

            {/* UTR Cards - 4 Cards Per Row */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "repeat(2, 1fr)",
                  md: "repeat(4, 1fr)",
                },
                gap: 2,
              }}
            >
              {eventData.payment_details.utrs.map((utr, index) => {
                const mode = (utr?.mode || "").toLowerCase();

                let modeColor = "#2563EB";
                let modeBg = "#EFF6FF";
                let modeBorder = "#BFDBFE";
                let modeIcon = <PaymentsIcon sx={{ fontSize: 17 }} />;

                if (mode === "cash") {
                  modeColor = "#059669";
                  modeBg = "#ECFDF5";
                  modeBorder = "#A7F3D0";

                  modeIcon = (
                    <AccountBalanceWalletIcon sx={{ fontSize: 17 }} />
                  );
                } else if (mode === "upi") {
                  modeColor = "#7C3AED";
                  modeBg = "#F5F3FF";
                  modeBorder = "#DDD6FE";

                  modeIcon = (
                    <PhoneAndroidIcon sx={{ fontSize: 17 }} />
                  );
                } else if (mode === "card") {
                  modeColor = "#EA580C";
                  modeBg = "#FFF7ED";
                  modeBorder = "#FED7AA";

                  modeIcon = (
                    <CreditCardIcon sx={{ fontSize: 17 }} />
                  );
                }

                return (
                  <Box
                    key={index}
                    sx={{
                      position: "relative",
                      p: 2,
                      borderRadius: "16px",
                      backgroundColor: "#FFFFFF",
                      border: "1px solid #E5E7EB",
                      boxShadow:
                        "0 4px 14px rgba(15, 23, 42, 0.05)",
                      overflow: "hidden",
                      transition: "all 0.25s ease",

                      "&:hover": {
                        transform: "translateY(-3px)",
                        boxShadow:
                          "0 8px 24px rgba(15, 23, 42, 0.10)",
                        borderColor: modeBorder,
                      },

                      "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        height: "3px",
                        backgroundColor: modeColor,
                      },
                    }}
                  >
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        sx={{
                          fontSize: "10px",
                          fontWeight: 700,
                          color: "black",
                          letterSpacing: "0.5px",
                          mb: 0.6,
                        }}
                      >
                        UTR No : {utr.utr_num}
                      </Typography>
                    </Box>

                    <Box sx={{ flex: 1 }}>
                      <Typography
                        sx={{
                          fontSize: "10px",
                          fontWeight: 700,
                          color: "black",
                          letterSpacing: "0.5px",
                          mb: 0.6,
                        }}
                      >
                        Transaction No : {utr.transaction_id}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "stretch",
                        gap: 1,
                        mb: 1.5,
                      }}
                    >
                      <Box sx={{ flex: 1 }}>
                        <Typography
                          sx={{
                            fontSize: "9px",
                            fontWeight: 700,
                            color: "#94A3B8",
                            letterSpacing: "0.5px",
                            mb: 0.6,
                          }}
                        >
                          PAYMENT MODE
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.7,
                            px: 0.8,
                            py: 0.2,
                            minHeight: "42px",
                            borderRadius: "8px",
                            backgroundColor: modeBg,
                            border: `1px solid ${modeBorder}`,
                            overflow: "hidden",
                          }}
                        >
                          <Box sx={{ color: modeColor, display: "flex" }}>
                            {modeIcon}
                          </Box>

                          {/* Mode + Wallet */}
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              minWidth: 0,
                              lineHeight: 1,
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "12px",
                                fontWeight: 800,
                                color: modeColor,
                                textTransform: "capitalize",
                                whiteSpace: "nowrap",
                                lineHeight: 1.1,
                              }}
                            >
                              {utr.mode || "N/A"}
                            </Typography>

                            {(utr.IsWallet === true || utr.IsWallet === "yes") && (
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  fontWeight: 600,
                                  color: "#94A3B8",
                                  mt: 0.2,
                                  lineHeight: 1,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Wallet
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </Box>


                      {/* Amount */}
                      <Box sx={{ flex: 1 }}>
                        <Typography
                          sx={{
                            fontSize: "9px",
                            color: "#94A3B8",
                            fontWeight: 700,
                            letterSpacing: "0.5px",
                            mb: 0.6,
                          }}
                        >
                          AMOUNT
                        </Typography>

                        <Box
                          sx={{
                            px: 1.2,
                            py: 0.5,
                            minHeight: "42px",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "8px",
                            backgroundColor: "#F8FAFC",
                            border: "1px solid #F1F5F9",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "19px",
                              fontWeight: 900,
                              color: "#059669",
                              letterSpacing: "-0.5px",
                            }}
                          >
                            ₹
                            {Number(utr.amount || 0).toLocaleString("en-IN")}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      {/* Avatar */}
                      <Box
                        sx={{
                          width: 30,
                          height: 30,
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background:
                            "linear-gradient(135deg, #6366F1, #8B5CF6)",
                          color: "#FFFFFF",
                          fontSize: "11px",
                          fontWeight: 800,
                          flexShrink: 0,
                        }}
                      >
                        {(utr.paid_by || "N")
                          .charAt(0)
                          .toUpperCase()}
                      </Box>

                      <Box sx={{ minWidth: 0 }}>
                        <Typography
                          sx={{
                            fontSize: "9px",
                            color: "#94A3B8",
                            fontWeight: 700,
                          }}
                        >
                          PAID BY
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: 700,
                            color: "#374151",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {utr.paid_by || "N/A"}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                );
              })}
            </Box>
          </Paper>
        )}
      </Box>

      {/* 5. Session Timeline Modal (Sub-Modal) */}
      <Modal open={openSessions} onClose={() => setOpenSessions(false)}>
        <Box
          sx={{
            ...mainModalStyle,
            width: { xs: "90%", sm: 550 },
            minHeight: "auto",
          }}
        >
          <Box
            sx={{
              px: 3,
              py: 2.5,
              borderBottom: "1px solid #E2E8F0",
              bgcolor: "#F8FAFC",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              position: "sticky",
              top: 0,
              zIndex: 5,
            }}
          >
            <Typography
              variant="h6"
              fontWeight={800}
              color="#334155"
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <CalendarMonthOutlinedIcon color="primary" /> Session Timeline
            </Typography>
            <IconButton
              onClick={() => setOpenSessions(false)}
              size="small"
              sx={{ bgcolor: "#E2E8F0", color: "#64748B" }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <Box sx={{ p: 3, bgcolor: "#fff" }}>
            {activeServiceSessions?.length === 0 ? (
              <Box sx={{ textAlign: "center", py: 5 }}>
                <Typography color="#94A3B8" fontWeight={600}>
                  No Sessions Scheduled Yet
                </Typography>
              </Box>
            ) : (
              <Stack spacing={2}>
                {activeServiceSessions.map((sess, i) => (
                  <Paper
                    key={i}
                    elevation={0}
                    sx={{
                      p: 2,
                      border: "1px solid #E2E8F0",
                      borderRadius: "12px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      bgcolor: "#F8FAFC",
                      borderLeft: "4px solid #3B82F6",
                      transition: "all 0.2s",
                      "&:hover": {
                        borderColor: "#3B82F6",
                        boxShadow: "0 4px 12px rgba(59, 130, 246, 0.1)",
                      },
                    }}
                  >
                    <Box sx={{ width: "80%", overflow: "hidden" }}>
                      <Typography
                        variant="body2"
                        fontWeight={800}
                        color="#1E293B"
                        sx={{ wordBreak: "break-word" }}
                      >
                        {sess.Professional_name}
                      </Typography>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{ mt: 1, flexWrap: "wrap", gap: 1 }}
                      >
                        <Typography
                          variant="caption"
                          color="#64748B"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            fontWeight: 600,
                          }}
                        >
                          <span style={{ color: "#10B981" }}>Start:</span>{" "}
                          {sess.actual_StartDate_Time} | {sess.start_time}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="#64748B"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            fontWeight: 600,
                          }}
                        >
                          <span style={{ color: "#EF4444" }}>End:</span>{" "}
                          {sess.actual_EndDate_Time} | {sess.end_time}
                        </Typography>
                      </Stack>
                    </Box>
                    <Avatar
                      sx={{
                        bgcolor: "#DBEAFE",
                        color: "#1D4ED8",
                        fontWeight: 800,
                        width: 35,
                        height: 35,
                      }}
                    >
                      {i + 1}
                    </Avatar>
                  </Paper>
                ))}
              </Stack>
            )}
          </Box>
        </Box>
      </Modal>
    </Box >
  );
};

export default PackageEventDetails;
